import { useEffect, useState } from "react";
import { Alert, Card, Col, Row } from "react-bootstrap";
import { listVolunteers } from "../services/api";

function AdminVolunteersPage() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await listVolunteers();
        setItems(res.data || []);
        if (res.mockMode) setStatus({ type: "warning", message: "Showing local mock data." });
      } catch (e) {
        setStatus({ type: "danger", message: "Failed to load volunteers." });
      }
    };
    load();
  }, []);

  return (
    <section>
      <Card className="glass-card text-light mb-3">
        <Card.Body>
          <h1 className="section-title mb-2">Volunteer Interests</h1>
          <p className="text-muted-soft mb-0">Recent volunteer sign-ups and interests.</p>
        </Card.Body>
      </Card>

      {status.message && <Alert variant={status.type}>{status.message}</Alert>}

      <Row className="g-3">
        {items.map((item) => (
          <Col
            md={6}
            key={item.id}
          >
            <Card className="resource-card text-light">
              <Card.Body>
                <div className="fw-bold">{item.name || "Anonymous"}</div>
                <div className="small text-muted-soft">
                  {item.email || ""} {item.phone ? `| ${item.phone}` : ""}
                </div>
                <div className="small text-muted-soft mt-2">Interests: {item.interests || ""}</div>
                <div className="small text-muted-soft">Availability: {item.availability || ""}</div>
                <p className="mt-2 mb-0">{item.message}</p>
                <div className="small text-muted-soft mt-2">{item.created_at || item.createdAt}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
        {items.length === 0 && (
          <Col>
            <Card className="resource-card text-light">
              <Card.Body className="small text-muted-soft">No volunteers found.</Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    </section>
  );
}

export default AdminVolunteersPage;
